import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import './chartSetup';
import { CHART_COLORS, defaultChartOptions } from './chartSetup';

const DEFAULT_COLORS = [
  CHART_COLORS.purple,
  CHART_COLORS.green,
  CHART_COLORS.amber,
  CHART_COLORS.rose,
  CHART_COLORS.cyan,
  CHART_COLORS.blue
];

const GroupedBarChartCard = ({
  title,
  labels = [],
  datasets = [],
  horizontal = false
}) => {
  const chartData = useMemo(() => ({
    labels,
    datasets: datasets.map((dataset, index) => ({
      label: dataset.label,
      data: dataset.values || [],
      backgroundColor: `${dataset.color || DEFAULT_COLORS[index % DEFAULT_COLORS.length]}cc`,
      borderRadius: 6,
      maxBarThickness: horizontal ? 20 : 36
    }))
  }), [labels, datasets]);

  const options = useMemo(() => ({
    ...defaultChartOptions,
    indexAxis: horizontal ? 'y' : 'x',
    scales: {
      x: {
        stacked: false,
        grid: { display: horizontal },
        ticks: { color: '#6b7280', maxRotation: horizontal ? 0 : 45, minRotation: 0 }
      },
      y: {
        stacked: false,
        beginAtZero: true,
        grid: { color: '#f3f4f6' },
        ticks: { color: '#6b7280', precision: 0 }
      }
    },
    plugins: {
      ...defaultChartOptions.plugins,
      legend: {
        ...defaultChartOptions.plugins.legend,
        position: 'bottom'
      }
    }
  }), [horizontal]);

  const hasData = datasets.some((dataset) => (dataset.values || []).some((value) => value > 0));

  if (!labels.length || !hasData) {
    return (
      <div className="h-56 flex items-center justify-center text-sm text-gray-500">
        No data available
      </div>
    );
  }

  return (
    <div>
      {title && <h3 className="text-base font-bold text-gray-900 mb-3">{title}</h3>}
      <div className="h-64" role="img" aria-label={`${title} grouped bar chart`}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default GroupedBarChartCard;
